const templateContent = {
  moons_possible_advanced: 'Eres candidato a usar moons, sin embargo, necesitamos tomar una muestra de tu sonrisa, para conocer la complejidad de tu caso',
  moons_advanced: 'Eres candidato a usar moons, pero necesitas citas presenciales con un doctor, debido a la dificultad de tu caso, el precio de tu tratamiento es:',
  moonsKit: 'Tu kit llegará en menos de 3 días laborales, después, agenda una llamada para hacer una muestra de tu sonrisa'
}

export default templateContent
